export type PaletteColor = {id: string; label: string; hex: string}

export const COLOR_PALETTE: PaletteColor[] = [
  {id: 'red', label: 'Red', hex: '#EF4444'},
  {id: 'orange', label: 'Orange', hex: '#FB923C'},
  {id: 'yellow', label: 'Yellow', hex: '#FACC15'},
  {id: 'green', label: 'Green', hex: '#4ADE80'},
  {id: 'teal', label: 'Teal', hex: '#14B8A6'},
  {id: 'blue', label: 'Blue', hex: '#3B82F6'},
  {id: 'violet', label: 'Violet', hex: '#7C5CFF'},
  {id: 'pink', label: 'Pink', hex: '#F472B6'},
  {id: 'silver', label: 'Silver', hex: '#D1D5DB'},
  {id: 'black', label: 'Black', hex: '#0B0814'},
]

export const PALETTE_IDS = COLOR_PALETTE.map((c) => c.id)
